import React from "react";

const PlansSectionHeader = ({ title, description }) => {
  return (
    <div className="purchaseSection text-gray-700">
      <div className={`purchaseMsgSection container mx-auto`}>
        <h2 className="section-heading agrandir text-center text-5xl mb-4">
          {title}
        </h2>

        <div className="text-xl lg:text-3xl text-center text-black">
          {description}
        </div>
      </div>
    </div>
  );
};

export default PlansSectionHeader;
